module.exports = __webpack_public_path__ + "img/avatar5.340a182d.png";